import { Component } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslocoPipe } from "@jsverse/transloco";
import { DialogBase } from "../../../common/dialog/dialog.base";

@Component({
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslocoPipe],
  templateUrl: "./push-permission-dialog.html",
  styleUrl: "./push-permission-dialog.css",
})
export class PushPermissionDialogComponent extends DialogBase<void, boolean> {}
